import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import { EmptyState } from '@famly/mf_data-display_empty-state';
import { kinderConnectCaptureSettingsEmptyStateE2eId } from './kinder-connect-capture-settings-e2e-ids';
/**
 * Shown in place of the children list when the search/filter combination matches no one.
 */
export const KinderConnectCaptureSettingsChildrenListEmptyState = () => (_jsx(EmptyState, { imageUrl: "", imageHeight: "0px", heading: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.settings.noMatchesHeading), body: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.settings.noMatchesBody), fullWidth: true, "data-e2e-id": kinderConnectCaptureSettingsEmptyStateE2eId }));
